import { useWindowSize } from "@/hooks/useIsMobile";
import sendGAEvent from "@/utils/gaEvent";
import SVG from "react-inlinesvg";

const Breadcrumb = ({ breadcrumbList = [] }) => {
  const { width } = useWindowSize();

  const handleClick = (isVideoPage) => {
    const isStoryOrVideoDetail =
      window?.location?.href?.includes("/video/") ||
      window?.location?.href?.includes("/story/");
    if (isStoryOrVideoDetail) {
      sendGAEvent({
        eventName: isVideoPage
          ? "VideoPage-BreadcrumbsClick"
          : "ArticlePage-BreadcrumbsClick",
        pageTitle: document?.title,
        pageLocation: window?.location?.href,
      });
    }
  };

  return (
    <div className="bg-gray-100 py-2 overflow-auto [&::-webkit-scrollbar]:hidden ">
      <nav className="text-gray-700   text-sm md:mx-4" aria-label="Breadcrumb">
        <ol className="list-none mx-2 md:mx-0 p-0 inline-flex divide-x-2">
          <li className="flex items-center px-2">
            <a
              href="/"
              className="text-gray-700 hover:text-primary flex"
              onClick={() => handleClick(false)}
            >
              {/* <div className="min-w-[14px] flex items-center">
                <SVG
                  className="w-3 h-3 mx-1 hover:text-primary"
                  src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/menuHome.svg"
                />
              </div> */}
              होम
            </a>
          </li>
          {breadcrumbList?.map((item, index) => (
             <>
              <li key={index} className="flex items-center px-2 line-clamp-1">
                {item?.icon && (
                  <div className="min-w-[14px]">
                    <SVG
                      className="w-3 h-3 mx-1 hover:text-primary"
                      src={item?.icon}
                    />
                  </div>
                )}
                <a
                  onClick={() => {
                    let currentPageVideoType =
                      window?.location?.href?.includes("/video/");

                    let isStoryOrVideoDetail =
                      window?.location?.href?.includes("/video/") ||
                      window?.location?.href?.includes("/story/");
                    if (isStoryOrVideoDetail) {
                      sendGAEvent({
                        eventName: currentPageVideoType
                          ? "VideoPage-BreadcrumbsClick"
                          : "ArticlePage-BreadcrumbsClick",
                        pageTitle: document?.title,
                        pageLocation: window?.location?.href,
                      });
                    }
                  }}
                  href={item?.canonical_url}
                  className="text-gray-700 whitespace-nowrap  hover:text-primary"
                  aria-current="page"
                >
                  {item?.title}
                </a>
              </li>
               
            </>
          ))}
        </ol>
      </nav>
    </div>
  );
};

export default Breadcrumb;
